'use client'

import { LoadingSpinner } from 'components/WebEv/Shop/HelperComponents/LoadingSpinner/LoadingSpinner'
import { getTokenFromBrowser } from 'components/_hooks/useGetMemberDataFromAppInjection'
import { useRouter } from 'next/navigation'
import { FC, useEffect, useState } from 'react'
import { useCurrentRegion } from 'stores/settings'

const ReferralPage: FC = () => {
	const [loading, setLoading] = useState(true)
	const router = useRouter()
	const region = useCurrentRegion()

	const regionPath = region !== '' ? `/${region}` : ''
	useEffect(() => {
		const jwt = getTokenFromBrowser()
		const referralPath = region !== '' ? `${region}/referral` : 'referral'

		if (jwt === null) {
			router.push(`${regionPath}/login?redirect_to=${referralPath}`)
			return
		}

		fetch(`/api/membership-details/auth?jwt=${jwt}`)
			.then((res) => {
				if (res.status === 200) {
					setLoading(false)
				} else {
					router.push(`${regionPath}/login?redirect_to=${referralPath}`)
				}
			})
			.catch(() => {
				router.push(`${regionPath}/login?redirect_to=${referralPath}`)
			})
	}, [router, regionPath, region])

	return (
		<>
			<div
				className="inner-paddings-x inner-paddings-y"
				style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
			>
				{loading && (
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', zIndex: 1000 }}>
						<LoadingSpinner />
					</div>
				)}

				<div style={{ visibility: loading ? 'hidden' : 'visible' }}>
					<div
						style={{ maxWidth: 1000, marginLeft: 'auto', marginRight: 'auto', minHeight: 'calc(100vh - 150px)', width: '90vw' }}
						id="friendbuylandingpage"
					/>
				</div>
			</div>
		</>
	)
}

export default ReferralPage
